module.exports = __webpack_public_path__ + "img/oottum-collective-main-bg.48e2e521.jpg";